import { Component, ViewChild, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-accident-details',
    templateUrl: './accident-details.component.html',
    styleUrls: ['./accident-details.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSelectModule,
        MatCheckboxModule,
        MatButtonModule
    ]
})
export class AccidentDetailsComponent implements OnInit {
  form: UntypedFormGroup;
  @ViewChild('accidentDate', { static: false }) accidentDateInput: any;

  constructor(private readonly fb: UntypedFormBuilder) {}
  ngOnInit(): void {
    this.form = this.createForm();
  }

  createForm(): UntypedFormGroup {
    return this.fb.group({
      accidentDate: [''],
      accidentTime: [''],
      accidentLocation: [''],
      description: [''],
      conditions: [''],
      weatherClear: [''],
      weatherCloudy: [''],
      weatherFog: [''],
      weatherSleet: [''],
      weatherSnow: [''],
      weatherRain: [''],
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.accidentDateInput?.nativeElement?.focus();
    }, 0);
  }

}
